<template>
  <table class="table mt-0 mb-0 full-width">
    <thead class="bg-light">
      <tr>
        <th
          scope="col"
          class="border-0 rwd-disabled">Data</th>
        <th
          scope="col"
          class="border-0 text-center">Użytkownik</th>
        <th
          scope="col"
          class="border-0 text-right">Pojemniki do zwrotu</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) of containersHistorySorted"
        :key="'container-history-' + index">
        <td>
          {{ formatDate(item.created_at) }}
        </td>
        <td class="text-center">
          {{ item.user_name || '-' }}
        </td>
        <td
          class="text-right"
          :class="getContainersColClass(item.containers_number)">
          {{ item.containers_number }}
        </td>
      </tr>
      <tr v-if="containersHistorySorted.length === 0">
        <td
          colspan="3"
          class="text-center">
          Brak elementów do wyświetlenia&hellip;
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import CalendarUtils from '@/utils/CalendarUtils.js';

export default {
  name: 'institution-containers-history',
  props: {
    containersHistory: {
      required: true,
      type: Array
    }
  },
  computed: {
    containersHistorySorted () {
      if (!this.containersHistory) {
        return [];
      }

      return [...this.containersHistory].sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();

        return dateB - dateA;
      });
    }
  },
  methods: {
    formatDate (date) {
      return CalendarUtils.formatDateForPHP(new Date(date));
    },
    getContainersColClass (containersNumber) {
      if (containersNumber === 0) {
        return 'text-success';
      }

      if (containersNumber > 0) {
        return 'text-warning';
      }

      return 'text-primary';
    }
  }
};
</script>
